module.exports = __webpack_public_path__ + "img/01_btu.352e3546.jpg";